import { getProfessionDisplayName } from "@bonliva-crm/common/data/professions";
import { TimeReportTemplateType } from "../enums";

export interface TimereportTemplateSettings {
  type: TimeReportTemplateType;
  professions: string[];
  rules?: TimereportTemplateRule[];
}

export type TimereportTemplateRule =
  | "isOffAllCustomerSettings"
  | "needSignatureTROkInApp";

type CustomerSettings = {
  needSignatureTROkInApp?: boolean;
  noApproval?: boolean;
  needSignature?: boolean;
  noApprovalMonthly?: boolean;
  noApprovalShortening?: boolean;
  noApprovalSpecial?: boolean;
};

export class TimereportTemplateConfig {
  constructor(
    public customerSettings: CustomerSettings,
    public templateSettings: TimereportTemplateSettings[] = []
  ) {}

  get rules(): Record<TimereportTemplateRule, boolean> {
    return {
      needSignatureTROkInApp: this.customerSettings.needSignatureTROkInApp,
      isOffAllCustomerSettings: ![
        "noApproval",
        "needSignature",
        "needSignatureTROkInApp",
        "noApprovalMonthly",
        "noApprovalShortening",
        "noApprovalSpecial"
      ].some((key) => this.customerSettings[key])
    };
  }

  getType(profession: string, checkRules = true): TimeReportTemplateType | null {
    if (!this.templateSettings.length) {
      return null;
    }

    for (const setting of this.templateSettings) {
      const rulesPass =
        setting.rules && checkRules
          ? setting.rules.some((rule) => this.rules[rule])
          : true;

      const type =
        rulesPass &&
        setting.professions.includes(getProfessionDisplayName(profession)) &&
        setting.type;

      if (type) {
        return type;
      }
    }

    return null;
  }
}
